import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const AdminLoading: React.FC = () => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
            <CircularProgress size={48} />
        </Box>
    );
};

export default AdminLoading;